import type { ChatMessage } from '../hooks/useSocket';

const LINKS_TTS_KEY = 'media-links';

interface Props {
  messages: ChatMessage[];
  speaking: boolean;
  speakingSourceKey: string | null;
  onSpeakText: (text: string, sourceKey: string) => void;
  onStopSpeaking: () => void;
  canPlayTts?: boolean;
}

export function SessionDetails({ messages, speaking, speakingSourceKey, onSpeakText, onStopSpeaking, canPlayTts = true }: Props) {
  const images = messages.flatMap((m) => m.images || []);
  const urlRegex = /(https?:\/\/[^\s)]+)/g;
  const urls: string[] = [];
  messages.forEach((m) => {
    let match;
    while ((match = urlRegex.exec(m.text)) !== null) urls.push(match[1]);
  });

  return (
    <div class="chat-subpanel">
      <h3 class="chat-subpanel-section-title">Media attached</h3>
      {images.length === 0 ? (
        <p class="chat-subpanel-muted">No media attached.</p>
      ) : (
        <div class="chat-subpanel-media-grid">
          {images.map((src, i) => (
            <button
              type="button"
              key={i}
              class="chat-subpanel-thumb"
              onClick={() => window.dispatchEvent(new CustomEvent('open-image-overlay', { detail: src }))}
            >
              <img src={src} alt="" />
            </button>
          ))}
        </div>
      )}

      <div class="chat-subpanel-section-head">
        <h3 class="chat-subpanel-section-title">Shared links</h3>
        {urls.length > 0 && (
          <button
            type="button"
            class={`tts-icon-btn tts-icon-btn--panel${speaking && speakingSourceKey === LINKS_TTS_KEY ? ' tts-icon-btn--active' : ''}`}
            disabled={!canPlayTts && !(speaking && speakingSourceKey === LINKS_TTS_KEY)}
            onClick={() => {
              if (speaking && speakingSourceKey === LINKS_TTS_KEY) onStopSpeaking();
              else if (canPlayTts) onSpeakText(`Links from this chat: ${urls.join('. ')}`, LINKS_TTS_KEY);
            }}
            title={
              !canPlayTts && !(speaking && speakingSourceKey === LINKS_TTS_KEY)
                ? 'Turn on sound (drawer + 🔊 on this session tab)'
                : speaking && speakingSourceKey === LINKS_TTS_KEY
                  ? 'Stop speech'
                  : 'Read links aloud'
            }
            aria-label={speaking && speakingSourceKey === LINKS_TTS_KEY ? 'Stop speech' : 'Read links aloud'}
          >
            {speaking && speakingSourceKey === LINKS_TTS_KEY ? '\u23F9' : '\u25B6'}
          </button>
        )}
      </div>
      {urls.length === 0 ? (
        <p class="chat-subpanel-muted">No links shared.</p>
      ) : (
        <ul class="chat-subpanel-link-list">
          {urls.map((url, i) => (
            <li key={i}>
              <a href={url} target="_blank" rel="noreferrer" class="chat-subpanel-link">
                {url}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
